import React, { useEffect } from "react";
import { ChatContainer } from "@/components/chat/ChatContainer";
import { useChatStore } from "@/store/chat";
import { useStoreManagementStore } from "@/store/storeManagementStore";
import { useAuthStore } from "@/store/authStore";
import { Navigate } from "react-router-dom";
import { toast } from "@/hooks/use-toast";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAnalytics } from "@/hooks/use-analytics";
import { trackEvent } from "@/services/analytics";
import { useTranslation } from "react-i18next";

export default function ChatPage() {
  const { stores, fetchStores, fetchEmployees, employees } =
    useStoreManagementStore();
  const { markAsRead, currentStoreId, setCurrentStoreId, initializeMessages } =
    useChatStore();
  const { user } = useAuthStore();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  // Initialize analytics tracking
  useAnalytics();

  // Check if user is authenticated
  useEffect(() => {
    if (!user) {
      toast({
        title: "Authentication Required",
        description: "You need to be logged in to access the chat",
        variant: "destructive",
      });
    }
  }, [user]);

  // Fetch stores when component mounts
  useEffect(() => {
    if (user) {
      // Try to initialize messages from existing state or storage
      initializeMessages();
      // Track chat page view with special properties
      trackEvent("chat_page_viewed", {
        mobile_view: isMobile,
      });
    }
  }, [user, isMobile, initializeMessages]);

  // Mark messages as read when the chat page is opened
  useEffect(() => {
    if (currentStoreId) {
      markAsRead();

      // Track messages marked as read
      trackEvent("messages_marked_read", {
        store_id: currentStoreId,
      });
    }
  }, [currentStoreId, markAsRead]);

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/auth" />;
  }

  return (
    <div className={`container mx-auto ${isMobile ? "p-0" : "p-4"}`}>
      <div
        className={`${
          isMobile ? "" : "rounded-lg border shadow-sm"
        } overflow-hidden`}
      >
        <ChatContainer />
      </div>
    </div>
  );
}
